// src/api/axiosInstances.ts
import axios, { AxiosInstance } from "axios";
import { SERVICES_URLS } from "@sajilni/config/constants";
import { setupInterceptors } from "./interceptors";

const createApiInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  setupInterceptors(instance);
  return instance;
};

export const baseApi = createApiInstance(SERVICES_URLS.MAIN_APP as string);
export const formApi = createApiInstance(
  SERVICES_URLS.FORM_BUILDER_APP as string
);
export const orderApi = createApiInstance(SERVICES_URLS.ORDER_APP as string);
export const notificationApi = createApiInstance(
  SERVICES_URLS.NOTIFICATION_APP as string
);
export const integrationApi = createApiInstance(
  SERVICES_URLS.INTEGRATION_APP as string
);
export const contentManagerApi = createApiInstance(
  SERVICES_URLS.CONTENT_MANGER_APP as string
);
export const malgaVirtualApi = createApiInstance(
  SERVICES_URLS.MALGA_VIRTUAL as string
);
export const paymentApi = createApiInstance(
  SERVICES_URLS.PAYMENT_APP as string
);

